var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"w-31"},[_c('span',{staticClass:"icon-size d-flex justify-content-center",domProps:{"innerHTML":_vm._s(_vm.link.icona)}})]),_vm._v("\n  "+_vm._s(_vm.link.label?.length > 30 ? _vm.link.label.substring(0, 30) + "..." : _vm.link.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }